import { gql } from "@apollo/client";

const GET_USERS = gql`
  query users(
  $params: QueryParams
  $name: String
  $email: String
  $type: String
  ) {
    users(
    params: $params
    name: $name
    email: $email
    type: $type
    ) {
      info {
        count
      }
      results {
        id
        firstName
        lastName
        email
        img
        type
      }
    }
  }
`;

export { GET_USERS };
